import { ModuleConditionalRoute, RouteConditions, StepConditionalRoute } from '@abiglobalhealth/go-types'

import { conditionsMatch } from '@/utils/conditions'

const getValidRoutes = <T extends ModuleConditionalRoute | StepConditionalRoute>({
  routesMatching,
  routes
}: {
  routesMatching: T[]
  routes: T[]
}): T[] => {
  if (routesMatching.length > 0) {
    // Sort routes by number of conditions
    return routesMatching.sort((a, z) => {
      const aConditions: number = a.conditions ? Object.keys(a.conditions).length : 0
      const zConditions: number = z.conditions ? Object.keys(z.conditions).length : 0

      return zConditions - aConditions
    })
  }

  // Filter routes without conditions
  return routes.filter((route) => !route.conditions)
}

export const getRouteByConditions = <T extends ModuleConditionalRoute | StepConditionalRoute>({
  userConditions,
  routes
}: {
  userConditions?: RouteConditions
  routes: T[]
}): T => {
  if (!userConditions) throw new Error('No user conditions provided')
  if (!routes || routes.length === 0) throw new Error('No routes provided')

  const routesMatching = routes.filter((route) => {
    const { conditions: routeConditions } = route
    return conditionsMatch({ userConditions, routeConditions })
  })

  const validRoutes = getValidRoutes({ routesMatching, routes })

  if (!validRoutes) throw new Error('No route found with conditions')

  // Return the first route (most conditions or no conditions)
  return validRoutes[0]
}
